import React from 'react';
import { About } from '../components/About';
export function AboutPage() {
  return <main data-id="element-1754">
      <About data-id="element-1755" />
    </main>;
}